import { render, staticRenderFns } from "./CBadge.vue?vue&type=template&id=2f7ef13e&scoped=true"
import script from "./CBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CBadge.vue?vue&type=style&index=0&id=2f7ef13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ef13e",
  null
  
)

export default component.exports